import { render, staticRenderFns } from "./HighlightedCategories.vue?vue&type=template&id=47c7a835&scoped=true"
import script from "./HighlightedCategories.vue?vue&type=script&lang=js"
export * from "./HighlightedCategories.vue?vue&type=script&lang=js"
import style0 from "./HighlightedCategories.vue?vue&type=style&index=0&id=47c7a835&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c7a835",
  null
  
)

export default component.exports